import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

function PopupPromo() {
  const [isVisible, setIsVisible] = useState(false);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    // Verificar si ya se cerró en esta sesión
    const dismissed = sessionStorage.getItem('popup_promo_dismissed');
    if (dismissed) return;

    // Cargar configuración del popup
    const fetchPopup = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/popup-promo`);
        if (response.ok) {
          const data = await response.json();
          if (data.activo && data.imagen_url) {
            // Mostrar después de 1 segundo
            setTimeout(() => {
              setConfig(data);
              setIsVisible(true);
            }, 1000);
          }
        }
      } catch (error) {
        console.error('Error cargando popup:', error);
      }
    };

    fetchPopup();
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('popup_promo_dismissed', 'true');
  };

  const handleClick = () => {
    if (config?.link_destino) {
      if (config.link_destino.startsWith('http')) {
        window.open(config.link_destino, '_blank');
      } else {
        window.location.href = config.link_destino;
      }
    }
    handleClose();
  };

  if (!isVisible || !config) return null;

  return (
    <>
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-60 z-[9998] transition-opacity duration-300"
        onClick={handleClose}
      />
      
      {/* Modal */}
        <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 pointer-events-none">
        <div 
            className="relative max-w-lg w-full pointer-events-auto animate-fade-in-up"
            onClick={(e) => e.stopPropagation()}
        >
            {/* Botón cerrar */}
            <button
            onClick={handleClose}
            className="absolute -top-3 -right-3 bg-white text-gray-600 hover:text-gray-900 rounded-full p-2 shadow-lg z-10 transition-colors"
            aria-label="Cerrar"
            >
            <X size={24} />
            </button>
            
            {/* Imagen - Desktop o Mobile según pantalla */}
            <div 
            className={`rounded-2xl overflow-hidden shadow-2xl ${config.link_destino ? 'cursor-pointer hover:scale-[1.02] transition-transform' : ''}`}
            onClick={config.link_destino ? handleClick : undefined}
            >
            {/* Imagen Mobile (visible solo en mobile) */}
            {config.imagen_url_mobile && (
                <img 
                src={config.imagen_url_mobile} 
                alt={config.titulo || 'Promoción'}
                className="w-full h-auto md:hidden"
                />
            )}
            
            {/* Imagen Desktop (visible solo en desktop, o en mobile si no hay imagen mobile) */}
            <img 
                src={config.imagen_url} 
                alt={config.titulo || 'Promoción'}
                className={`w-full h-auto ${config.imagen_url_mobile ? 'hidden md:block' : ''}`}
            />
            </div>
            
            {/* Indicador de link */}
            {config.link_destino && (
            <p className="text-center text-white text-sm mt-3 opacity-80">
                Haz clic en la imagen para ver más
            </p>
            )}
        </div>
        </div>
    </>
  );
}

export default PopupPromo;